var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{class:_vm.classModifier,attrs:{"variant":"none"}},[_vm._v(_vm._s(_vm.$t(("lead.cluster." + _vm.cluster))))])}
var staticRenderFns = []

export { render, staticRenderFns }